module.exports = __webpack_public_path__ + "static/media/black-tie.203f40fb.jpg";